import {
  TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO,
  TIPO_PROGRAMACAO_DIARIA_INSPECAO,
  TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS,
} from '../../../constants/ids';

export const MAX_GRUPOS_CELULA = 3;
export const MAX_NSIRS_PREVIEW = 2;

export const getResumoPorTipo = row =>
  (Array.isArray(row?.resumoPorTipo) ? row.resumoPorTipo : []);

export const labelNsirs = nsir => {
  if (!nsir) return '-';
  return nsir.codigo || nsir.titulo || nsir.equipamento || '-';
};

const amostraLength = grupo => {
  if (Array.isArray(grupo?.nsirs) && grupo.nsirs.length) return grupo.nsirs.length;
  if (Array.isArray(grupo?.itens) && grupo.itens.length) return grupo.itens.length;
  return 0;
};

export const amostraRestante = grupo => {
  const qtd = Number(grupo?.quantidade) || 0;
  return Math.max(0, qtd - amostraLength(grupo));
};

/**
 * Resumo tipado do item (lista no formulário / modal).
 * Deslocamento → De/Para (+ malha); Inspeção → NSIRs; Manutenção → placa;
 * demais → malha/cidade quando houver.
 */
export const formatItemDescricao = item => {
  if (!item) return '-';

  const inspecao = item.tipoId === TIPO_PROGRAMACAO_DIARIA_INSPECAO;
  const deslocamento = item.tipoId === TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO
    || !!(item.cidadeDe || item.cidadePara);
  const parts = [];

  if (deslocamento) {
    parts.push(`De: ${item.cidadeDe || '-'} → Para: ${item.cidadePara || '-'}`);
  } else if (item.nsirCodes?.length) {
    parts.push(`NSIRs: ${item.nsirCodes.join(', ')}`);
  } else if (item.nsirLabels?.length) {
    parts.push(`NSIRs: ${item.nsirLabels.join(', ')}`);
  } else if (item.veiculo || item.veiculoPlaca) {
    parts.push(`Veículo: ${item.veiculo || item.veiculoPlaca}`);
  }

  if (!inspecao && (item.malha || item.malhaNome)) {
    parts.push(item.malha || item.malhaNome);
  }

  if (!inspecao && !deslocamento && item.cidade) {
    parts.push(item.cidade);
  }

  return parts.length ? parts.join(' · ') : '-';
};

/**
 * Preview tipado de um grupo de resumoPorTipo (célula da listagem).
 * Inspeção → NSIRs; Deslocamento → cidades; Manutenção → placa; senão só N× Tipo.
 */
export const formatTipoPreview = grupo => {
  if (!grupo) return '';

  const qtd = Number(grupo.quantidade) || 0;
  const tipo = grupo.tipo || 'Outros';
  const prefix = `${qtd}× ${tipo}`;
  const rest = amostraRestante(grupo);

  if (grupo.tipoId === TIPO_PROGRAMACAO_DIARIA_INSPECAO && Array.isArray(grupo.nsirs) && grupo.nsirs.length) {
    const shown = grupo.nsirs.slice(0, MAX_NSIRS_PREVIEW).map(labelNsirs);
    const suffix = rest > 0 ? ` +${rest}` : '';
    return `${prefix} · ${shown.join(', ')}${suffix}`;
  }

  if (
    grupo.tipoId === TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO
    && Array.isArray(grupo.itens)
    && grupo.itens.length
  ) {
    const item = grupo.itens[0];
    const route = `${item.cidadeDe || '-'} → ${item.cidadePara || '-'}`;
    const malha = item.malha || item.malhaNome;
    const detail = malha ? `${route} · ${malha}` : route;
    const suffix = rest > 0 ? ` +${rest}` : '';
    return `${prefix} · ${detail}${suffix}`;
  }

  if (
    grupo.tipoId === TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS
    && Array.isArray(grupo.itens)
    && grupo.itens.length
  ) {
    const detail = formatItemDescricao(grupo.itens[0]);
    const suffix = rest > 0 ? ` +${rest}` : '';
    return detail && detail !== '-'
      ? `${prefix} · ${detail}${suffix}`
      : `${prefix}${suffix}`;
  }

  if (Array.isArray(grupo.itens) && grupo.itens.length) {
    const detail = formatItemDescricao(grupo.itens[0]);
    if (detail && detail !== '-') {
      const suffix = rest > 0 ? ` +${rest}` : '';
      return `${prefix} · ${detail}${suffix}`;
    }
  }

  return prefix;
};

export const STATUS_LABEL = {
  SINCRONIZADA: 'Sincronizada',
  PENDENTE: 'Pendente',
  NAO_SINCRONIZADA: 'Não sincronizada',
  ERROR_SINCRONIZAR: 'Erro ao sincronizar',
};

export const statusLabel = status => STATUS_LABEL[status] || status || '-';
